import React from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { selectSearch, setSearchOption } from "amadeusredux/lib/searchSlice";
import { adultsOptions, childrenAgeOptions, childrenOptions } from "../utils";

export const AdultsSelect = () => {
  const { adults } = useSelector(selectSearch);
  const dispatch = useDispatch();

  let options = [...adultsOptions];
  console.log(adultsOptions)
  return (
    <Select
      value={adults}
      onChange={(val) => {
        dispatch(setSearchOption({ property: "adults", data: val }));
      }}
      isSearchable={false}
      defaultValue={options[0]}
      options={options}
    />
  );
};

export const ChildrenSelect = () => {
  const { children } = useSelector(selectSearch);
  const dispatch = useDispatch();

  let options = [...childrenOptions];

  return (
    <Select
      value={children}
      onChange={(val) => {
        dispatch(setSearchOption({ property: "children", data: val }));
      }}
      isSearchable={false}
      defaultValue={options[0]}
      options={options}
    />
  );
};

export const ChildrenAgeSelect = (props) => {
  const { index } = props;
  const { childrenages } = useSelector(selectSearch);
  const dispatch = useDispatch();

  let options = [...childrenAgeOptions];

  return (
    <Select
      value={childrenages[index]}
      onChange={(val) => {
        let tmp = [...childrenages];
        tmp[index] = val;
        dispatch(setSearchOption({ property: "childrenages", data: tmp }));
      }}
      isSearchable={false}
      defaultValue={options[0]}
      options={options}
    />
  );
};
